import { ShiftSelector } from '../../ShiftSelector';
import { useKanbanFilterStore } from '../hooks/useKanbanFilterStore';

export const KanbanShiftSelector = () => {
  const selectedShifts = useKanbanFilterStore((state) => state.selectedShifts);
  const setSelectedShifts = useKanbanFilterStore((state) => state.setSelectedShifts);

  return <ShiftSelector selectedShifts={selectedShifts} setSelectedShifts={setSelectedShifts} />;
};
